import { ref as c, computed as p, reactive as d } from "vue";
import { F as e, T as n, B as t, R as o, M as s } from "./chunks/maps.DxC18PqJ.js";
const k = {
  paragraph: "#000000",
  buttonText: "#ffffff",
  link: "#1C8BF1",
  buttonBackground: "#000000",
  secondaryButtonBackground: "#000000",
  secondaryButtonText: "#FFFFFF",
  background: {
    base: "#ffffff"
  },
  icon: "#000000",
  countdown: "#F2F2F2",
  countdownText: "#000000",
  countdownNumber: "#000000"
}, i = {
  heading: "#000000",
  paragraph: "#000000",
  link: "#1C8BF1",
  buttonText: "#FFFFFF",
  buttonBackground: "#000000",
  secondaryButtonBackground: "#000000",
  secondaryButtonText: "#FFFFFF",
  background: {
    base: "#FFFFFF"
  },
  icon: "#000000",
  perks: "#000000",
  countdown: "#F2F2F2",
  countdownText: "#000000",
  countdownNumber: "#000000"
}, y = {
  heading: {
    spec: {
      key: "Playfair+Display",
      name: "Playfair Display",
      cssName: "Playfair Display",
      type: "serif",
      fontType: e.Google,
      source: ""
    },
    style: "bold",
    textTransform: n.None
  },
  paragraph: {
    spec: {
      key: "Open+Sans",
      name: "Open Sans",
      cssName: "Open Sans",
      type: "sans-serif",
      fontType: e.Google,
      source: ""
    },
    style: "regular",
    textTransform: n.None
  },
  formFieldName: {
    spec: {
      key: "Open+Sans",
      name: "Open Sans",
      cssName: "Open Sans",
      type: "sans-serif",
      fontType: e.Google,
      source: ""
    },
    style: "regular",
    textTransform: n.None
  },
  other: {
    spec: {
      key: "Open+Sans",
      name: "Open Sans",
      cssName: "Open Sans",
      type: "sans-serif",
      fontType: e.Google,
      source: ""
    },
    style: "regular",
    textTransform: n.None
  },
  perks: {
    spec: {
      key: "Open+Sans",
      name: "Open Sans",
      cssName: "Open Sans",
      type: "sans-serif",
      fontType: e.Google,
      source: ""
    },
    style: "regular",
    textTransform: n.None
  },
  countdown: {
    spec: {
      key: "Open+Sans",
      name: "Open Sans",
      cssName: "Open Sans",
      type: "sans-serif",
      fontType: e.Google,
      source: ""
    },
    style: "regular",
    textTransform: n.None
  },
  button: {
    spec: {
      key: "Open+Sans",
      name: "Open Sans",
      cssName: "Open Sans",
      type: "sans-serif",
      fontType: e.Google,
      source: ""
    },
    style: "regular",
    textTransform: n.None
  },
  secondaryButton: {
    spec: {
      key: "Open+Sans",
      name: "Open Sans",
      cssName: "Open Sans",
      type: "sans-serif",
      fontType: e.Google,
      source: ""
    },
    style: "regular",
    textTransform: n.None
  }
}, l = {
  note: {
    style: t.Solid,
    cornerRadius: {
      kind: o.Medium
    },
    padding: {
      top: 8,
      right: 16,
      bottom: 8,
      left: 16,
      format: s.Em
    }
  },
  layer: {
    style: t.Solid,
    cornerRadius: {
      kind: o.Medium
    },
    padding: {
      top: 14,
      right: 22,
      bottom: 14,
      left: 22,
      format: s.Em
    }
  },
  exit: {
    style: t.Solid,
    cornerRadius: {
      kind: o.Medium
    },
    padding: {
      top: 14,
      right: 22,
      bottom: 14,
      left: 22,
      format: s.Em
    }
  },
  inliner: {
    style: t.Solid,
    cornerRadius: {
      kind: o.Medium
    },
    padding: {
      top: 14,
      right: 22,
      bottom: 14,
      left: 22,
      format: s.Em
    }
  }
}, f = {
  opacity: 100,
  cornerRadius: {
    kind: o.Medium
  }
}, m = {
  opacity: 100,
  cornerRadius: {
    kind: o.Medium
  },
  border: {
    color: "#D9D9D9",
    thickness: 1
  }
}, g = {
  color: "#000000",
  opacity: 50
};
function T(u) {
  const a = c(u), r = p(
    () => l[a.value] || l.layer
  );
  return d({
    colors: { ...i },
    fonts: { ...y },
    button: { ...r.value },
    secondaryButton: { ...r.value },
    background: a.value === "inliner" ? { ...m } : { ...f },
    overlay: { ...g }
  });
}
export {
  y as a,
  l as b,
  f as c,
  i as d,
  m as e,
  g as f,
  k as n,
  T as useDefaultStyles
};
//# sourceMappingURL=p-components.useDefaultStyles.js.map
